/**
 * This file is the source of truth for the following block of
 * questionnaire-related constants.
 */
export const PAGE_TYPE_OL = "ol";
export const PAGE_TYPE_OL_IMAGE = "ol-image";
export const PAGE_TYPE_IMAGE = "image";
export const PAGE_TYPE_COLOR = "color";
export const PAGE_TYPE_SOVA3D = "sova3d";
// Tridify no longer supported
// export const PAGE_TYPE_TRIDIFY = "tridify";
/**
 * These constants are used to identify the various backgrounds a questionnaire
 * page can have.
 * ol: OpenLayers map
 * ol-image: OpenLayers image (interactive image)
 * image: static image background
 * color: monochrome background
 * sova3d: Sova3D interactive 3D map
 * tridify: Tridify interactive 3D model
 */
export const PAGE_TYPE_OPTIONS = [
    PAGE_TYPE_OL,
    PAGE_TYPE_IMAGE,
    PAGE_TYPE_OL_IMAGE,
    PAGE_TYPE_COLOR,
    PAGE_TYPE_SOVA3D, // DEPRECATED
    // PAGE_TYPE_TRIDIFY,
];
/**
 * English language values for labeling the PAGE_TYPE_OPTIONS
 */
export const PAGE_TYPE_OPTION_TEXTS = [
    "Interactive map",
    "Interactive image",
    "Background image",
    "Color",
    "Sova3d model",
    // "Tridify model",
];
/**
 * Indicates whether using a particular PAGE_TYPE_OPTIONS requires a license
 */
export const PAGE_TYPE_OPTION_NEEDS_LICENSE = [
    false,
    false,
    false,
    false,
    "feature:questionnaire:3d",
    // "feature:questionnaire:3d",
];
export const PAGE_LAYOUT_WIDE = "wide";
export const PAGE_LAYOUT_NARROW = "narrow";
/**
 * These constants are used to identify the page width for a questionnaire page.
 */
export const PAGE_LAYOUT_OPTIONS = [
    PAGE_LAYOUT_NARROW,
    PAGE_LAYOUT_WIDE,
];
/**
 * English language values for labeling the PAGE_LAYOUT_OPTIONS
 */
export const PAGE_LAYOUT_OPTION_TEXTS = [
    "Narrow",
    "Wide",
];
export const PAGE_ALIGNMENT_LEFT = "left";
export const PAGE_ALIGNMENT_CENTER = "center";
export const PAGE_ALIGNMENT_RIGHT = "right";
/**
 * These constants are used to identify the page alignment for a questionnaire page.
 */
export const PAGE_ALIGNMENT_OPTIONS = [
    PAGE_ALIGNMENT_LEFT,
    PAGE_ALIGNMENT_CENTER,
    PAGE_ALIGNMENT_RIGHT,
];
/**
 * English language values for labeling the PAGE_ALIGNMENT_OPTIONS
 */
export const PAGE_ALIGNMENT_OPTION_TEXTS = [
    "Left",
    "Center",
    "Right",
];
//# sourceMappingURL=questionnaireConstants.js.map